import styled from 'styled-components'
import { rgba, media, radiuses, colors } from 'styles'

const StyledInfoShort = styled.div`
  align-items: flex-start;
  border-right: 0.1rem solid ${colors.divider};
  font-size: 1.4rem;

  .avatar.half {
    margin-right: 4rem;

    .image {
      position: relative;
      cursor: pointer;
      overflow: hidden;
      border-radius: ${radiuses.large};
    }
  }

  .interaction-icons {
    display: flex;
    margin-top: 1rem;
    text-transform: uppercase;
    justify-content: space-between;

    .icon {
      text-align: center;
      cursor: pointer;
      font-size: 0.75em;
      flex: 1;
    }
    .icon__image {
      display: inline-flex;
      height: 4rem;
      width: 4rem;
      justify-content: center;
      align-items: center;
      margin-bottom: 0.5rem;
    }
    svg {
      width: 3.5rem;
      height: 3rem;
    }
    .icon g, .icon path {
      fill: ${colors.textMain};
    }
  }
  .icon-sendMessage .st1 {
    stroke: ${colors.mainBackground};
  }
  .icon:hover g, .icon:hover path, .icon.in-hotlist g {
    fill: ${colors.highlight};
  }
  .username {
    margin: 0 0 1.2rem;
    color: ${colors.highlight};
  }
  .username--mobile {
    display: none;
  }
  .category, .value {
    flex: 1 0 40%;
  }
  .value {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  ${media.tablet`
    width: 100%;
    padding-right: 0;
    border-right: 0;
  `}

  ${media.mobile`
    flex-direction: column;
    .info {
      margin-top: 2rem;
    }
    .half {
      width: 100%;
    }
    .username--mobile {
      display: block;
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      margin: 0;
      padding: 2rem;
      font-size: 2rem;
      text-align: center;
      background: linear-gradient(transparent, ${colors.main});
      color: ${colors.mainInverted};
    }
    .row {
      font-size: 2rem;
    }
    .category {
      width: 20rem;
    }
    .icon {
      flex: 1;
      padding: 1rem;
      font-weight: bold;
      border-radius: ${radiuses.large};
      background: ${rgba(colors.main, 0.1)}
    }
  `}

  ${media.phone`
    .image {
      margin-bottom: 3rem;
    }
    .category {
      width: 16rem;
    }
  `}
`

export default StyledInfoShort
